/**
 * 售后 / 签收
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/after_sales_new',
    name: 'afterSalesNewEntry',
    component: () => import('@/views/afterSalesNew/entry.vue'),
    children: [
      {
        path: '',
        name: 'afterSalesNew',
        component: () => import('@/views/afterSalesNew/index.vue'),
        meta: {
          title: '售后服务'
        }
      },
      {
        path: 'form',
        name: 'afterSalesForm',
        component: () => import('@/views/afterSalesNew/form.vue'),
        meta: {
          title: '售后表单'
        }
      },
      {
        path: 'result',
        name: 'AfterSaleResult',
        component: () => import('@/views/afterSalesNew/result.vue'),
        meta: {
          title: '提交结果'
        }
      },
      {
        path: 'progress',
        name: 'AfterSaleProgress',
        component: () => import('@/views/afterSalesNew/progress.vue'),
        meta: {
          title: '售后进度'
        }
      },
      {
        path: 'logistics',
        name: 'AfterSaleNewLogistics',
        component: () => import('@/views/afterSalesNew/logistics.vue'),
        meta: {
          title: '填写单号'
        }
      }
    ]
  },
  {
    path: '/after_sales',
    name: 'afterSales',
    component: () => import('@/views/afterSales/entry.vue'),
    children: [
      {
        // 老的售后首页（申请入口）已下线，直接落到我的售后列表
        path: '',
        redirect: '/userCenter/afterSales'
      },
      {
        // 售后列表已收进用户中心（/userCenter/afterSales，与卡券/订单同级）。
        // 老地址保留跳转，并把 query 带过去（列表页依赖 load_data 等参数）
        path: 'list',
        name: 'afterSalesList',
        redirect: to => ({ path: '/userCenter/afterSales', query: to.query })
      },
      {
        path: 'apply_suc',
        name: 'AfterSaleApplySuc',
        component: () => import('@/views/afterSales/apply_suc.vue'),
        meta: {
          title: '售后进度'
        }
      },
      {
        path: 'after_logistics',
        name: 'afterLogistics',
        component: () => import('@/views/afterSales/logistics.vue'),
        meta: {
          title: '售后快递'
        }
      },
      {
        path: '/partition',
        name: 'partition',
        component: () =>
          import(
            /* webpackChunkName: "common" */
            '@/views/partition/index.vue'
          ),
        meta: {
          title: '节日礼包'
        }
      }
    ]
  },
  {
    path: '/password_bind',
    name: 'PasswordBind',
    component: () => import('@/views/cards/passwordBind.vue'),
    meta: {
      title: '签收'
    }
  }
];
